import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { initialPediatricTraumaScoreState } from '../store/pediatricTraumaScore.reducers'
import { setPtsData } from '../store/pediatricTraumaScore.actions'

export function* getPTS(pcrDoc: IPcr) {
  let ptsPrNabcData = {}

  if (pcrDoc.prNabc) {
    const ptsPrNeuroKeys = Object.keys(initialPediatricTraumaScoreState)
    ptsPrNabcData = getSelectedDataFromObject(pcrDoc.prNabc, ptsPrNeuroKeys)
  }

  if (Object.keys(ptsPrNabcData).length !== 0 || pcrDoc.prGcsQualifier?.length !== 0) {
    yield put(
      setPtsData({ ...ptsPrNabcData, qualifier: pcrDoc.prGcsQualifier, qualifierPNNV: pcrDoc.prGcsQualifierPNNV })
    )
  }
}
